import { Stack, Typography, Button } from '@mui/material'
import { ForwardedRef, forwardRef } from 'react'

interface Props {
  text: string | JSX.Element
  button: string | JSX.Element
  onClick: () => unknown
  icon?: JSX.Element
  color?: string
  bgcolor?: string
}

export const SnackbarComponent = forwardRef(function SnackbarComponent(
  {
    icon,
    text,
    button,
    color = 'white',
    bgcolor = '#30353ade',
    onClick,
  }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <Stack
      ref={ref}
      sx={{
        color,
        bgcolor,
        borderRadius: '8px',
        padding: '13.5px 13px 13.5px 20px',
        boxSizing: 'border-box',
        width: '340px',
        height: '48px',
      }}
      justifyContent="space-between"
      alignItems="center"
      direction="row"
    >
      <Stack alignItems="center" direction="row">
        {icon}
        <Typography
          color="inherit"
          variant="subtitle4"
          sx={{ marginRight: '12px' }}
        >
          {text}
        </Typography>
      </Stack>
      <Button
        onClick={onClick}
        color="secondary"
        sx={{
          width: typeof button !== 'string' ? '11px' : 'wrap-content',
          height: '11px',
          minWidth: '11px',
          padding: 0,
        }}
      >
        {button}
      </Button>
    </Stack>
  )
})
